import { Component, input, linkedSignal, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PaymentMethodSelectionElementComponent } from './payment-method-selection-element/payment-method-selection-element.component';
import { ButtonComponent } from 'app/shared/components/button/button.component';
import { SelectablePaymentType } from 'app/shared/models/payment-configuration.model';

type ModelFormGroup<T> = FormGroup<{
  [K in keyof T]: FormControl<T[K]>;
}>;

type PaymentMethodForm = ModelFormGroup<{ paymentMethod: SelectablePaymentType }>;

@Component({
  selector: 'ez-payment-method-selection',
  imports: [ReactiveFormsModule, PaymentMethodSelectionElementComponent, ButtonComponent],
  templateUrl: './payment-method-selection.component.html',
  styleUrl: './payment-method-selection.component.scss',
})
export class PaymentMethodSelectionComponent {
  readonly paymentMethods = input<SelectablePaymentType[]>([]);
  readonly chosePaymentMethod = output<SelectablePaymentType>();

  readonly form = linkedSignal<SelectablePaymentType[], PaymentMethodForm | undefined>({
    source: () => this.paymentMethods(),
    computation: (paymentMethods, previous) => {
      if (paymentMethods.length === 0) {
        return undefined;
      }
      const [defaultValue] = paymentMethods;
      const form =
        previous?.value ??
        new FormGroup({
          paymentMethod: new FormControl<SelectablePaymentType>(defaultValue, {
            nonNullable: true,
            validators: [Validators.required],
          }),
        });
      form.setValue({ paymentMethod: defaultValue });
      return form;
    },
  });

  onSubmit() {
    const paymentMethod = this.form()!.value.paymentMethod!;
    this.chosePaymentMethod.emit(paymentMethod);
  }
}
